import { observable } from "mobx";
import { Type } from "class-transformer";
import type { IRefund } from "./types";
import RefundChargeResponse from "./refundChargeResponse";
import RefundPermittedActionsResponse from "./refundPermittedActionsResponse";
import RefundApprovalResponse from "./refundApprovalResponse";
import RefundOriginalTransferPaymentResponse from "./refundOriginalTransferPaymentResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class TransferRefundResponse {
  id!: string;

  @observable
  refundPaymentTemplateId!: string;

  @observable
  refundAmount!: number;

  @observable
  @Type(() => RefundChargeResponse)
  charge?: RefundChargeResponse;

  @observable
  @Type(() => RefundPermittedActionsResponse)
  permittedActions!: RefundPermittedActionsResponse;

  @observable
  @Type(() => RefundApprovalResponse)
  approvals!: RefundApprovalResponse[];

  @observable
  officialRecordId?: string;

  @observable
  @Type(() => RefundOriginalTransferPaymentResponse)
  originalPayment?: RefundOriginalTransferPaymentResponse;
}

export default class TransferRefund extends TransferRefundResponse implements IRefund {
  @observable
  isSelectable: boolean;
}
